import {DateTime} from 'luxon'

import {currDateWithTimeZone} from '../../utils/time'
import {Venue} from '../venue/types'
import {BookedCycle} from './types'

export type CycleToShow = BookedCycle & {disabled: boolean, toPay: boolean, elIndex?: number, invoicePdf?: string}

export const prepareCyclesForShow = (cycles: BookedCycle[], timeZone: Venue['timeZone'] = 'Asia/Jerusalem'): CycleToShow[] => {
  const firstUnpaidCycleIndex = cycles.findIndex(cycle => !cycle.isPaid)

  const currentDate = currDateWithTimeZone(timeZone)

  const currentCycleIndex = cycles.findIndex(el => {
    const startDate = DateTime.fromMillis(el.startDate).toUTC()
    const endDate = DateTime.fromMillis(el.endDate).toUTC()
    return currentDate > startDate.toMillis() && currentDate < endDate.toMillis()
  })

  return cycles.reduce<CycleToShow[]>((acc, el, i) => {
    const showInBilling = i <= Math.max(currentCycleIndex, 0)
    if (showInBilling || el.isPaid) {
      return [...acc, {
        ...el,
        elIndex: i + 1,
        toPay: !el.isPaid,
        disabled: showInBilling,
        showInBilling: showInBilling || el.isPaid,
        isFirstUnpaid: firstUnpaidCycleIndex === i,
      } satisfies CycleToShow]
    }
    if (i === firstUnpaidCycleIndex) {
      return [...acc, {
        ...el,
        elIndex: i + 1,
        toPay: true,
        disabled: true,
      } satisfies CycleToShow]
    }
    return acc
  }, [])
}